// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.25 4.33594V19.6644L9.58579 12.0002L17.25 4.33594ZM8.5 5.00015V19.0002H6.5V5.00015H8.5Z"}}]};

const PreviousFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'previous-filled',
    ref,
    icon: element,
  },
));

PreviousFilledIcon.displayName = 'PreviousFilledIcon';

export default PreviousFilledIcon;
